<template>
  <div>
    <el-row type="flex">
      <el-col :xs="20" :sm="14" :md="14" :lg="14" :offset="5" class="mobile-step">
        <el-steps :space="200" :active="active" finish-status="success" align-center>
          <el-step title="商品信息"></el-step>
          <el-step title="收货地址"></el-step>
          <!--<el-step title="下单条件"></el-step>-->
          <el-step title="支付方式" v-if="!isSingle"></el-step>
          <el-step title="确认发布"></el-step>
        </el-steps>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  props: ['active'],
  components: {
  },
  created () {
    this.checkIsSingle()
  },
  data () {
    return {
      form: {
        region: ''
      }
    }
  },
  methods: {
    checkIsSingle () {
      this.isSingle = this.$route.fullPath.indexOf('buyer') > -1 ? true: false
    }
  },
  watch:{
    $route(){
      this.checkIsSingle()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media screen and (max-width:760px){
  .mobile-step {
    margin-left: 8.8% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/components/Steps.vue